import { put, takeEvery, call } from "redux-saga/effects";
import {
  FETCH_EXPIRYRETURNDETAILS_INIT_ACTION,
  FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNDETAILS_FAIL_ACTION,
  FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
  FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNVIEW_FAIL_ACTION,
  ADD_EXPIRY_CREDITNOTES_INIT_ACTION,
  ADD_EXPIRY_CREDITNOTES_SUCCESS_ACTION,
  ADD_EXPIRY_CREDITNOTES_FAIL_ACTION,
  PDF_EXPIRY_RETURN_REPORT_INIT_ACTION,
  PDF_EXPIRY_RETURN_REPORT_SUCCESS_ACTION,
  PDF_EXPIRY_RETURN_REPORT_FAIL_ACTION,
  FETCH_EXPIRY_RETUNREJECTED_INIT_ACTION,
  FETCH_EXPIRY_RETUNACCEPTED_INIT_ACTION,
  FETCH_EXPIRY_ORDERDETAIL_ACCEPT_INIT,
  FETCH_EXPIRY_ORDERDETAIL_REJECT_INIT,
  UPDATE_EXPIRY_APPROVED_QTY_INIT,
  UPDATE_EXPIRY_APPROVED_QTY_SUCCESS,
  UPDATE_EXPIRY_APPROVED_QTY_FAIL,
  UPDATE_EXPIRY_PURCHASEORDER_TOTALS_INIT,
  UPDATE_EXPIRY_PURCHASEORDER_TOTALS_SUCCESS,
  UPDATE_EXPIRY_PURCHASEORDER_TOTALS_FAIL,
} from "./action";

import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";

const expiryReturnsListParams = {
  page: 1,
  filter: "",
  searchquery: "",
};

function* fetchExpiryReturns(value) {
  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");

  const pageno =
    !value.value || value.value.page === undefined ? 1 : value.value.page;

  const searchquery =
    !value.value || value.value.searchquery === undefined
      ? ""
      : value.value.searchquery;

  const status =
    !value.value || value.value.filter === undefined ? "" : value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderType=expiryReturn&orderTo=${distributorProfId}&search=${searchquery}&status=${status}&limit=10&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!res.ok) throw res;

    const resJSON = yield res.json();

    yield put({
      type: FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    yield put({
      type: FETCH_EXPIRYRETURNDETAILS_FAIL_ACTION,
      error: err,
    });
  }
}

/* ============================
   2️⃣ Fetch Expiry Return Items
   ============================ */
function* fetchExpiryReturnView(value) {
  const token = localStorage.getItem("token");

  const orderId = value.value.item.item.id;
  const pageno = value.value.page === undefined ? 1 : value.value.page;

  try {
    const res = yield fetch(
      `${appConfig.ip}/orderDetails?orderId=${orderId}&limit=5&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!res.ok) throw res;

    const resJSON = yield res.json();

    yield put({
      type: FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    yield put({
      type: FETCH_EXPIRYRETURNVIEW_FAIL_ACTION,
      error: err,
    });
  }
}

function* CreditNotesAdd(value) {
  try {
    const token = localStorage.getItem("token");
    const distributorProfId = localStorage.getItem("distributorId");
    const formData = new FormData();

    formData.append("attachmentType", "credit-notes");
    formData.append("name", "icon");
    formData.append("icon", value.value.imgUrl, value.value.imgUrl.name);

    const res = yield fetch(`${appConfig.ip}/attachments/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!res.ok) throw res;

    const resJSON = yield res.json();
    const data = {
      crdtTo: value.value.crdtTo,
      crdtFrom: value.value.crdtFrom,
      crdtToGST: value.value.crdtToGST,
      addrInfoChmst: value.value.addrInfoChmst,
      descp: value.value.descp,
      qnty: value.value.qnty,
      amnt: value.value.amnt,
      imgUrl: resJSON.data.documentUrl,
      returnId: value.value.id,
    };

    const creditNoteRes = yield fetch(
      `${appConfig.ip}/creditNotes?crdtFrom=${distributorProfId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      },
    );

    if (!creditNoteRes.ok) throw creditNoteRes;

    const creditNoteJSON = yield creditNoteRes.json();

    yield put({
      type: FETCH_EXPIRYRETURNDETAILS_INIT_ACTION,
    });
    yield toast.success("Credit note uploaded", {
      autoClose: 3000,
      transition: Flip,
    });
    yield put({
      type: ADD_EXPIRY_CREDITNOTES_SUCCESS_ACTION,
      payload: creditNoteJSON,
    });
  } catch (err) {
    yield put({
      type: ADD_EXPIRY_CREDITNOTES_FAIL_ACTION,
      error: err,
    });
  }
}

function* returnrejected(value) {
  const token = localStorage.getItem("token");
  const orderId = value.value.order.item.id;

  const {
    approvedQtyMap,
    approvedAmountMap,
    approvedTaxMap,
  } = value.value;

  try {
    // Update items before changing the order status.
    for (const itemId in approvedQtyMap) {
      yield call(updateApprovedQuantity, {
        value: {
          id: itemId,
          approvedQntty: approvedQtyMap[itemId],
          approvedAmount: approvedAmountMap[itemId],
          taxAmount: approvedTaxMap ? approvedTaxMap[itemId] : 0,
        },
      });
    }

    // Change order status.
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder/changeStatus/${orderId}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status: "rejected" }),
      },
    );

    if (!res.ok) throw res;

    // Refresh the main list after the status change succeeds.
    yield call(fetchExpiryReturns, {
      value: expiryReturnsListParams,
    });

    yield toast.success("Expiry return rejected", {
      autoClose: 3000,
      transition: Flip,
    });
  } catch (err) {
    console.error(err);
  }
}

function* returnaccept(value) {
  const token = localStorage.getItem("token");
  const orderId = value.value.order.item.id;

  const {
    approvedQtyMap,
    approvedAmountMap,
    approvedTaxMap,
  } = value.value;

  try {
    // Update items before changing the order status.
    for (const itemId in approvedQtyMap) {
      yield call(updateApprovedQuantity, {
        value: {
          id: itemId,
          approvedQntty: approvedQtyMap[itemId],
          approvedAmount: approvedAmountMap[itemId],
          taxAmount: approvedTaxMap ? approvedTaxMap[itemId] : 0,
        },
      });
    }

    // Change order status.
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder/changeStatus/${orderId}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status: "accepted" }),
      },
    );

    if (!res.ok) throw res;

    // Refresh the main list after the status change succeeds.
    yield call(fetchExpiryReturns, {
      value: expiryReturnsListParams,
    });

    yield toast.success("Expiry return accepted", {
      autoClose: 3000,
      transition: Flip,
    });
  } catch (err) {
    console.error(err);
  }
}

function* returnacceptOne(value) {
  let datas = { orderStatus: "approved" };
  const { id, orderId, approvedQntty, approvedAmount, taxAmount } = value.value;
  const token = localStorage.getItem("token");

  try {
    yield call(updateApprovedQuantity, {
      value: {
        id,
        approvedQntty,
        approvedAmount,
        taxAmount,
      },
    });

    // Update item status.
    const res = yield fetch(`${appConfig.ip}/orderDetails/changeStatus/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datas),
    });

    if (!res.ok) throw res;

    yield toast.success("Item accepted", {
      autoClose: 3000,
      transition: Flip,
    });

    // Refresh the main list after the status change succeeds.
    yield call(fetchExpiryReturns, {
      value: expiryReturnsListParams,
    });

    // Refresh modal items.
    yield put({
      type: FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
      value: {
        item: { item: { id: orderId } },
        page: 1,
      },
    });
  } catch (err) {
    console.error(err);
  }
}

function* returnrejectedOne(value) {
  let datas = { orderStatus: "rejected" };
  const { id, orderId, approvedQntty, approvedAmount, taxAmount } = value.value;
  const token = localStorage.getItem("token");
  try {
    yield call(updateApprovedQuantity, {
      value: {
        id,
        approvedQntty,
        approvedAmount,
        taxAmount,
      },
    });

    // Update item status.
    const res = yield fetch(`${appConfig.ip}/orderDetails/changeStatus/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datas),
    });

    if (!res.ok) throw res;

    yield toast.success("Item Rejected", {
      autoClose: 3000,
      transition: Flip,
    });

    // Refresh the main list after the status change succeeds.
    yield call(fetchExpiryReturns, {
      value: expiryReturnsListParams,
    });

    // Refresh modal items.
    yield put({
      type: FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
      value: {
        item: { item: { id: orderId } },
        page: 1,
      },
    });
  } catch (err) {
    console.error(err);
  }
}

function* updateApprovedQuantity(value) {
  const token = localStorage.getItem("token");
  const { id, approvedQntty, approvedAmount, taxAmount } = value.value;

  try {
    const res = yield fetch(`${appConfig.ip}/orderDetails/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        approvedQntty,
        approvedAmount,
        taxAmount,
      }),
    });

    if (!res.ok) throw res;

    yield put({
      type: UPDATE_EXPIRY_APPROVED_QTY_SUCCESS,
      payload: {
        id,
        approvedQntty,
        approvedAmount,
      },
    });
  } catch (err) {
    yield put({ type: UPDATE_EXPIRY_APPROVED_QTY_FAIL, error: err });
  }
}

function* updatePurchaseOrderTotalsSaga(action) {
  const token = localStorage.getItem("token");
  const { orderId, totalApprovedAmount, totalClaimAmount } = action.value;

  try {
    const res = yield fetch(`${appConfig.ip}/purchaseOrder/${orderId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        totalApprovedAmount,
        totalClaimAmount,
      }),
    });

    if (!res.ok) throw res;

    yield put({
      type: UPDATE_EXPIRY_PURCHASEORDER_TOTALS_SUCCESS,
      payload: {
        orderId,
        totalApprovedAmount,
        totalClaimAmount,
      },
    });
  } catch (err) {
    yield put({
      type: UPDATE_EXPIRY_PURCHASEORDER_TOTALS_FAIL,
      error: err,
    });
  }
}

/* ============================
   3️⃣ PDF for Expiry Returns
   ============================ */
function* pdfExpiryReturnFullData(value) {
  const token = localStorage.getItem("token");

  const orderId = value.value.item.orderDetail.orderId.id;
  const ordername = value.value.item.orderFrom.fullName;
  const ordermob = value.value.item.orderFrom.mobileNo;
  const orderNo = value.value.item.orderNo;
  const email = value.value.item.chmstDtls.email;
  const address = value.value.item.addr + value.value.item.pincode;
  const pharmacy = value.value.item.orderFrom.orgName;
  const city = value.value.item.city;
  let totalClaimAmount = 0;
  let totalApprovedAmount = 0;

  try {
    const res = yield fetch(`${appConfig.ip}/orderDetails?orderId=${orderId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) throw res;

    const resJSON = yield res.json();
    const count = resJSON.count;


    const doc = new jsPDF("l", "mm", "a4");

    const status = value.value.item.status;
    const tableColumn = [
      "#",
      "Item\nCode",
      "Item\nName",
      "Batch\nNo",
      "Invoice\nNo",
      "Purchase\nDate",
      "Expiry\nDate",
      "Price",
      "Order\nQty",
      ...(status === "accepted" ? ["Appr. Qty", "GST %", "GST\nAmount", "Offer/Scheme", "Claim\nAmount", "Appr. Amt"]
        : ["GST %", "GST\nAmount", "Offer", "Claim\nAmount"]),
    ];

    const tableRows = [];

    resJSON.rows.forEach((report, i) => {

      const claimAmt = Number(report.claimAmountWithTax || 0);
      const apprAmt = Number(report.approvedAmount || 0);

      totalClaimAmount += claimAmt;
      totalApprovedAmount += apprAmt;
      const row = [
        i + 1,
        report.itemCode?.drugCode || "-",
        report.itemName || report.itemCode?.drugName || "-",
        report.batchNo || "-",
        report.purchaseInvoiceNo || "-",
        report.purchaseDate
          ? new Date(report.purchaseDate).toLocaleDateString()
          : "-",
        report.expiryDate
          ? new Date(report.expiryDate).toLocaleDateString()
          : "-",
        report.price || "0",
        report.qntty || "0",
      ];

      if (status === "accepted") {
        row.push(report.approvedQntty ?? report.qntty ?? "0");
        row.push(report.taxPercentage || "0");
        row.push(report.taxAmount || "0");
        row.push(report.offer || "-");
        row.push(report.claimAmountWithTax || "0");
        row.push(report.approvedAmount || "0");
      } else {
        row.push(report.taxPercentage || "0");
        row.push(report.taxAmount || "0");
        row.push(report.offer || "-");
        row.push(report.claimAmountWithTax || "0");
      }

      tableRows.push(row);
    });



    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: { halign: "left", fontSize: 8 },
      headStyles: { fillColor: [23, 104, 183], halign: "center" },
      margin: { top: 65 },
    });

    const finalY = doc.lastAutoTable.finalY || 70;

    doc.setFontSize(10);
    doc.text(`Order No : ${orderNo}`, 11, 13);
    doc.text(`Name : ${ordername}`, 11, 19);
    doc.text(`Pharmacy : ${pharmacy}`, 11, 25);
    doc.text(`Mobile : ${ordermob}`, 11, 30);
    doc.text(`Email : ${email}`, 11, 35);
    doc.text(`Address : ${address}`, 11, 40);
    doc.text(`City : ${city}`, 11, 45);

    doc.setFontSize(13);
    doc.text("Item Details", 11, 55);
    doc.setFontSize(12);
    doc.text(`${count} Items`, 11, 60);
    doc.setFontSize(11);

    // Total Claim Amount
    doc.text(
      `Total Claim Amount : ${totalClaimAmount.toFixed(2)}`,
      285,
      finalY + 12,
      { align: "right" }
    );

    // Show Approved total ONLY if accepted
    if (status === "accepted") {
      doc.text(
        `Total Approved Amount : ${totalApprovedAmount.toFixed(2)}`,
        285,
        finalY + 20,
        { align: "right" }
      );
    }
    doc.save(`${ordername}- ${orderNo}.pdf`);

    yield put({
      type: PDF_EXPIRY_RETURN_REPORT_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    yield put({
      type: PDF_EXPIRY_RETURN_REPORT_FAIL_ACTION,
      error: err,
    });
  }
}

/* ============================
   4️⃣ Watcher
   ============================ */
export function* ExpiryReturnsActionWatcher() {
  yield takeEvery(FETCH_EXPIRYRETURNDETAILS_INIT_ACTION, fetchExpiryReturns);

  yield takeEvery(FETCH_EXPIRYRETURNVIEW_INIT_ACTION, fetchExpiryReturnView);

  yield takeEvery(ADD_EXPIRY_CREDITNOTES_INIT_ACTION, CreditNotesAdd);

  yield takeEvery(
    PDF_EXPIRY_RETURN_REPORT_INIT_ACTION,
    pdfExpiryReturnFullData,
  );

  yield takeEvery(FETCH_EXPIRY_RETUNREJECTED_INIT_ACTION, returnrejected);
  yield takeEvery(FETCH_EXPIRY_RETUNACCEPTED_INIT_ACTION, returnaccept);
  yield takeEvery(FETCH_EXPIRY_ORDERDETAIL_ACCEPT_INIT, returnacceptOne);
  yield takeEvery(FETCH_EXPIRY_ORDERDETAIL_REJECT_INIT, returnrejectedOne);
  yield takeEvery(UPDATE_EXPIRY_APPROVED_QTY_INIT, updateApprovedQuantity);
  yield takeEvery(
    UPDATE_EXPIRY_PURCHASEORDER_TOTALS_INIT,
    updatePurchaseOrderTotalsSaga,
  );
}
